import { render, staticRenderFns } from "./AgentAddcomment.vue?vue&type=template&id=3fabc5cb&scoped=true&"
import script from "./AgentAddcomment.vue?vue&type=script&lang=js&"
export * from "./AgentAddcomment.vue?vue&type=script&lang=js&"
import style0 from "./AgentAddcomment.vue?vue&type=style&index=0&id=3fabc5cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fabc5cb",
  null
  
)

export default component.exports